"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdAnalyticsPlatform = void 0;
const AdAnalyticsPlacementTypes_1 = require("../../entity/AdAnalyticsPlacementTypes");
const createAdAnalyticsPlatform = () => ({
    key: 'facebook',
    name: '',
    media: [
        AdAnalyticsPlacementTypes_1.AdAnalyticsMedia.fromJSON({
            key: 'audience_network',
            name: '',
            placements: [
                AdAnalyticsPlacementTypes_1.AdAnalyticsPlacement.fromJSON({
                    key: 'all_placements',
                    name: '',
                }),
            ],
        }),
    ],
});
exports.createAdAnalyticsPlatform = createAdAnalyticsPlatform;
